// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:04:53

export default {
  "id": "zombies-and-guns",
  "slug": "zombies-and-guns",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/78fd113a09774296baaa628b45b7a07f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/78fd113a09774296baaa628b45b7a07f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Zombies and Guns",
      "description": "Urgently save: the evil spirits are coming!\nYou are a Fighter, who is attacked by hordes of zombies and all sorts of evil spirits! Don't let them eat you alive!",
      "instructions": "The goal of the game is to destroy zombies in a variety of ways, constantly improve your weapons and complete as many levels as possible!\n\nControls:\nMovement - W, S, A, D\nMenu - ESC\nShot - LMB\nAdditional shot - RMB\nDash - Space\nShop - Enter\nThrow a grenade - G\nPlace a turret - E\nCall for support - Q\nTake additional weapons - Tab",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "guns",
        "shoot-em-up",
        "stickman",
        "survival",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "僵尸与枪支",
      "description": "紧急救援：邪恶的灵魂正在靠近！\n你是一名战士，正被僵尸和各种各样的邪恶灵魂所攻击！不要让他们将你生吞活剥！",
      "instructions": "游戏目标是以各种方式摧毁僵尸，不断升级你的武器，尽可能完成更多关卡！\n\n控制方式：\n移动 - W, S, A, D\n菜单 - ESC\n射击 - 左鼠标按钮\n额外射击 - 右鼠标按钮\n冲刺 - 空格\n商店 - 回车\n投掷手榴弹 - G\n放置炮塔 - E\n呼叫支援 - Q\n获取额外武器 - Tab",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "枪械",
        "射击",
        "木偶人",
        "生存",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "僵屍與槍枝",
      "description": "緊急救援：邪靈即將來襲！\n你是一名戰士，被僵尸和各種邪靈群攻！不要讓他們將你生吞活剥！",
      "instructions": "遊戲目標是通過各種方式消滅僵屍，不斷升級你的武器並盡可能完成更多關卡！\n\n控制方式：\n移動 - W, S, A, D\n選單 - ESC\n射擊 - 選擇鍵\n追加射擊 - 右選擇鍵\n疾跑 - 空格鍵\n商店 - Enter\n丟擲手榴彈 - G\n放置砲塔 - E\n呼叫支援 - Q\n攜帶額外武器 - Tab",
      "genres": [
        "射手"
      ],
      "tags": [
        "槍械",
        "射擊遊戲",
        "條件人",
        "生存",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "僵屍與槍械",
      "description": "緊急救援：惡靈將至！\n你是一個戰士，被僵尸和各種惡靈群攻！不要讓他們將你生吞活剥！",
      "instructions": "遊戲目標是通過各種方式摧毀僵屍，不斷提升你的武器，並盡可能完成更多關卡！\n\n控制方式：\n移動 - W, S, A, D\n選單 - ESC\n射擊 - 左鍵\n追加射擊 - 右鍵\n加速 - 空格\n商店 - Enter\n投擲手榴彈 - G\n放置砲塔 - E\n呼叫支援 - Q\n取得額外武器 - Tab",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "槍械",
        "射擊遊戲",
        "條漫",
        "生存",
        "僵屍"
      ]
    },
    "ja": {
      "title": "ゾンビと銃",
      "description": "緊急避難：邪悪な霊が迫っている！\nあなたは戦士であり、ゾンビや様々な邪悪な霊の群れに攻撃されている！彼らに生きたまま食べられないようにしよう！",
      "instructions": "ゲームの目標は、様々な方法でゾンビを倒し、武器を常に向上させ、できるだけ多くのレベルをクリアすることです！\n\nコントロール：\n移動 - W, S, A, D\nメニュー - ESC\n発射 - 左クリックボタン\n追加発射 - 右クリックボタン\nダッシュ - スペースキー\nショップ - Enter\n手榴弾投擲 - G\nタワー設置 - E\n支援要請 - Q\n追加武器取得 - Tab",
      "genres": [
        "シューティング"
      ],
      "tags": [
        "銃",
        "シューティングアップ",
        "スティックマン",
        "サバイバル",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "좀비와 권총",
      "description": "긴급 구조: 악한 영혼들이 다가오고 있습니다!\n당신은 막대한 죽은자와 모든种类의 악한 영혼들에 공격받고 있는 전사입니다! 그들에게 살려먹히지 마세요!",
      "instructions": "게임의 목표는 다양한 방식으로 좀비를 파괴하고, 무기를 지속적으로 개선하고 가능한 많은 레벨을 완료하는 것입니다!\n\n컨트롤:\n이동 - W, S, A, D\n메뉴 - ESC\n발사 - 마우스 왼쪽 버튼\n추가 발사 - 마우스 오른쪽 버튼\ndash - 공백\n숍 - Enter\n최루탄 던지기 - G\n타워 설치 - E\n지원 요청 - Q\n추가 무기 가져오기 - Tab",
      "genres": [
        "射手"
      ],
      "tags": [
        "기관총",
        "쏘아라",
        "스틱맨",
        "생존",
        "죽음의 짐승"
      ]
    },
    "fr": {
      "title": "Zombis et armes à feu",
      "description": "Sauvez-vous d'urgence : les esprits maléfiques approchent !\nVous êtes un Combattant, attaqué par des hordes de zombies et toutes sortes d'esprits maléfiques ! Ne laissez pas qu'ils vous mangent vivant !",
      "instructions": "L'objectif du jeu est de détruire les zombies de diverses manières, d'améliorer constamment vos armes et de terminer le plus de niveaux possible !\n\nContrôles :\nMouvement - W, S, A, D\nMenu - ESC\nTir - LMB\nTir supplémentaire - RMB\nSaut - Espace\nBoutique - Entrée\nLancer une grenade - G\nPlacer une tourelle - E\nAppeler du soutien - Q\nPrendre des armes supplémentaires - Tab",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "armes",
        "tirez",
        "stickman",
        "survie",
        "zombie"
      ]
    }
  }
};
